import { Injectable } from '@angular/core';

import * as amplitude from "@amplitude/analytics-browser";

import { EnvironmentConfig } from '../environmentConfig';
import { AmplitudeEvents, AmplitudeEvent } from '../enums/AmplitudeEvent';

@Injectable({
    providedIn: 'root',
})
export class AmplitudeService {

    private _sdkInitialized = false;

    constructor(private environment: EnvironmentConfig) {}

    public get isAmplitudeEnabled(): boolean {
        return this.environment.utils.Amplitude.enabled;
    }

    public get isAmplitudeInitialized(): boolean {
        return this._sdkInitialized;
    }

    public initialize(): void {
        if (this.isAmplitudeEnabled && !this.isAmplitudeInitialized) {
            amplitude.init(this.environment.utils.Amplitude.apiKey);
            this._sdkInitialized = true;
            console.debug('Amplitude: initialized');
        }
    }

    public logEvent(event: AmplitudeEvents, properties?: any): void {
        if (this.isAmplitudeInitialized) {
            amplitude.track(event, properties);
            console.debug('Amplitude: event sent');
        }
    }

    public logEventV2(event: AmplitudeEvent): void {
        if (this.isAmplitudeInitialized) {
            event.log(amplitude);
            console.debug('Amplitude: event sent');
        }
    }

    public identify(
        id: string,
        username: string,
        email: string,
        organization_id: number,
        site: string
    ): void {
        if (this.isAmplitudeInitialized && amplitude) {
            amplitude.setUserId(id);
            const identify = new amplitude.Identify();
            identify
                .set("username", username)
                .set("email", email)
                .set("organization_id", organization_id)
                .set("site", site)
            amplitude.identify(identify)
            console.debug('Amplitude: user identified');
        }
    }
}
